import { useNavigate } from "react-router-dom";

export default function Unauthorized() {
  const navigate = useNavigate();

  return (
    <div className="h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white p-10 rounded-2xl shadow-lg max-w-md text-center">
        <h1 className="text-3xl font-bold text-red-600 mb-4">
          🚫 Access Denied
        </h1>

        <p className="text-gray-600 mb-6">
          You do not have permission to access this page.
        </p>

        <div className="flex justify-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="btn btn-secondary"
          >
            Go Back
          </button>

          <button
            onClick={() => navigate("/dashboard")}
            className="btn btn-primary"
          >
            Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
